export default __webpack_public_path__ + "static/media/home_mouseterfully_done.80d3eb3a.mp3";